'use client';
import React from 'react';

export default function TopBar() {
  return (
    <div style={{ width: '100%', backgroundColor: '#404040', padding: '5px 20px', color: '#fff' }}>
      <div style={{ maxWidth: '1140px', margin: '0 auto', fontSize: '11px', textTransform: 'uppercase', fontFamily: 'Lato, sans-serif', fontWeight: 700 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '4px' }}>
          {/* Left: Contact Info */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <a href="tel:3216634402" style={{ color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}
              className="topbar-link">
              <i className="fas fa-mobile-alt" style={{ marginRight: '2px' }}></i>
              (321) 663-4402
            </a>
            <span style={{ color: '#fff', display: 'flex', alignItems: 'center', gap: '4px' }}>
              <i className="fas fa-map-marker-alt" style={{ marginRight: '2px' }}></i>
              601 Davisville Rd, Willow Grove, PA 19090
            </span>
            <a href="mailto:gottschprisupport@gottschpri.com" style={{ color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '4px' }}
              className="topbar-link">
              <i className="fas fa-envelope" style={{ marginRight: '2px' }}></i>
              gottschprisupport@gottschpri.com
            </a>
          </div>
          {/* Right: CTA */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <a
              href="#contact"
              style={{
                backgroundColor: '#0e6585',
                color: '#fff',
                padding: '4px 12px',
                borderRadius: '4px',
                textDecoration: 'none',
                fontWeight: 700,
                fontSize: '11px',
                letterSpacing: '1px',
                transition: 'background 0.2s',
              }}
              className="topbar-cta"
            >
              Get a Quote
            </a>
          </div>
        </div>
      </div>
      <style jsx>{`
        .topbar-link:hover { color: #f89921 !important; }
        .topbar-cta:hover { background-color: #333 !important; }
      `}</style>
    </div>
  );
}
